import Notifications from '@mui/icons-material/Notifications'
import React, { useContext, useState } from 'react'
import useInfiniteScroll from 'react-infinite-scroll-hook'
import { NotificationContext } from 'src/consumer/context/NotificationContextProvider'
import {
  NotificationIconButton,
  NotificationListItemContainer,
  NotificationListItemText,
  NotificationMenuComponent,
  NotificationMenuHeading,
} from './components/styledComponents'
import { Fade, MenuItem } from '@mui/material'
import NotificationListItemSkeleton from './components/NotificationListItemSkeleton'
import NotificationListItemComponent from './components/NotificationListItemComponent'

export default function NotificationsList() {
  const {
    notificationList: notificationsData,
    refreshNotifications,
    updateNotifications,
    moreNotificationsAvailable,
    markNotificationAsRead,
  } = useContext(NotificationContext)
  const [notificationsListAnchor, setNotificationListAnchor] = useState(false)
  // const moreNotificationsAvailable = true

  function toggleNotificationsShow(event) {
    setNotificationListAnchor((prev) => {
      if (Boolean(prev)) {
        return null
      }
      return event.currentTarget
    })
  }
  function handleOpenNotifications(event) {
    setNotificationListAnchor(event.currentTarget)
  }
  function handleCloseNotifications(event) {
    setNotificationListAnchor(null)
  }

  const [sentryRef] = useInfiniteScroll({
    hasNextPage: moreNotificationsAvailable,
    onLoadMore: () => {
      console.log('loading more')
      updateNotifications()
    },
    rootMargin: '0px 0px 20px 0px',
  })

  return (
    <>
      <NotificationIconButton onClick={handleOpenNotifications}>
        <Notifications />
      </NotificationIconButton>
      <NotificationMenuComponent
        anchorEl={notificationsListAnchor}
        open={Boolean(notificationsListAnchor)}
        onClose={handleCloseNotifications}
        MenuListProps={{
          'aria-labelledby': 'notification',
          role: 'listbox',
        }}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'center',
        }}
        TransitionComponent={Fade}
        TransitionProps={{ timeout: 100 }}
      >
        <NotificationMenuHeading>Notifications</NotificationMenuHeading>
        <hr
          style={{
            margin: '0px 15px',
            // color: '#5500f382'
            // opacity: 1,
          }}
        ></hr>
        {notificationsData?.length <= 0 && (
          <MenuItem disabled>
            <NotificationListItemContainer>
              <NotificationListItemText primary="You have no notifications." />
            </NotificationListItemContainer>
          </MenuItem>
        )}
        {notificationsData?.map((option, index) => (
          <NotificationListItemComponent
            key={option?.notificationId || option?.id || `notification-${index}`}
            index={index}
            notificationData={option}
            refreshNotifications={refreshNotifications}
            handleMarkRead={markNotificationAsRead}
            closeNotificationList={handleCloseNotifications}
          />
        ))}
        {moreNotificationsAvailable && <NotificationListItemSkeleton menuItemRef={sentryRef} />}
      </NotificationMenuComponent>
    </>
  )
}
